import Vue from "vue";
//import axios from "axios";
//import { table } from "console";
import { getActions, COLUMNS } from "@/components/internal_requests/help_ir";

const vue = new Vue();
export var dialog = {
  type: "",
  title: "",
  visible: false,
  responsableId: null,
  comment: "",
  internalRequestId: 0
};
export var showDetail = false;
export var detailData = {
  requestsId: 0,
  comments: [],
  descripcionLaga: "",
  descripcionCorta: ""
};

export const GetInternalRequestWithoutAssigment = async function (currentUser) {
  //console.log("GetInternalRequestWithoutAssigment");
  //var request = null;
  let tableData = [];
  /*
  if (request) cancel();
  const axiosSource = axios.CancelToken.source();
  request = { cancel: axiosSource.cancel, msg: "Loading..." };
  */
  const {
    /*EmployeeId,
    DireccionID,*/
    CompanySelected,
    IsSupervisor
  } = currentUser;

  //const person = EmployeeId; //> 0 ? this.selectedEmployee : EmployeeId;

  const params = {
    PersonId: 0,
    DirectionId: 0,
    Company: CompanySelected,
    Status: 0,
    CreateByMe: false,
    IAmASupervisor: false,
    All: true,
    isSupervisor: IsSupervisor,
    page: 1,
    limit: 10000,
    skit: 0 // != null ? this.selectedCreator : this.currentUser.EmployeeId
  };

  if (currentUser && IsSupervisor === true) {
    // this.loading = true;
    /*
        await vue.$http
            .get("/api/InternalServiceRequest/GetSummaryInternalService", {
            params: params,
            timeout: 3 * 60 * 100
            })
            .then(response => {
            const { data } = response;
            this.cardValues = data;
            });
        */
    await vue.$http
      .get(
        "/api/InternalServiceRequest/GetListInternalServiceRequestSupervisor/",
        {
          params: params,
          //cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000
        }
      )
      .then((resp) => {
        //console.log("respuesta de nuevas solicitudes: ", resp);
        const { Items /*, CurrentPage, ItemCount*/ } = resp.data;
        /*
          this.currentPage = CurrentPage;
          this.total = ItemCount;
          */
        tableData = Items;

        //vue.$store.commit("SET_UPDATE_INTERNAL_REQUESTS", false);
        /*
          this.$nextTick(function() {
            let p = this.$refs[this.activeTab].pagination;
            this.$refs[this.activeTab].pagination = {
              ...p,
              currentPage: CurrentPage,
              total: ItemCount
            };
          });
        */
      })
      .catch((err) => console.error(err))
      .finally(() => {
        /*this.loading = false*/
      });

    return tableData;
  } else {
    return tableData;
  }
};
/*
const cancel = function () {
  this.request.cancel();
  this.clearOldRequest("Cancelled");
};
*/
export const InternalRequestColumns = COLUMNS;

export const InternalRequestActions = (p) =>
  getActions(p).new.filter(
    (action) =>
      action.command === "set" ||
      action.command === "addComment" ||
      action.command ===
        "details" /*action.command.includes("set" || "details" || "cancell")*/
  );

export const InternalRequestActionHandler = (option) =>
  handlePushAction(option);

const handlePushAction = function (option) {
  //console.log("handlePushAction: ", option);
  switch (option.command) {
    case "set": {
      dialog.internalRequestId = option.row.Id;
      dialog.title = "Asignar responsable";
      dialog.type = "set";
      dialog.visible = true;
      //console.log("dialogo: ", dialog);
      break;
    }

    case "addComment": {
      dialog.internalRequestId = option.row.Id;
      dialog.title = "Agregar comentario";
      dialog.type = "addComment";
      dialog.visible = true;
      break;
    }

    case "cancell": {
      this.__helperRequestChangeStatus(4, option);
      break;
    }

    case "work": {
      this.__helperRequestChangeStatus(1, option);
      break;
    }

    case "close": {
      this.__helperRequestChangeStatus(2, option);
      break;
    }

    case "details": {
      //console.log ("entro a details: ", option);
      dialog.internalRequestId = option.row.Id;
      detailData = {
        requestsId: option.row.Id,
        comments: [],
        descripcionLaga: option.row.Descripcion,
        descripcionCorta: option.row.corta
      };
      if (option.row != null && option.row.Activities != null) {
        const c = option.row.Activities.filter((a) => (a.Type = 1));
        detailData.comments = JSON.parse(JSON.stringify(c));
      }
      showDetail = true;
      break;
    }

    default:
      break;
  }
};
